import { loadingAsyncState, HttpResult, AsyncState, unloadedAsyncState } from "widgets-for-react";
import { FormState, FormData } from "./types";
import * as Immutable from 'immutable'

export let postFormSubmissionState = (form_id:number, form_state:FormState) : AsyncState<string> => {
  if(form_state.form_data.kind != "loaded") return unloadedAsyncState()
 // if(form_state.form_data.value.form.store_submissions_locally) return unloadedAsyncState()
  let steps = form_state.form_data.value.steps
  let userEmail = ""
  let ConfirmationEmail = "true"
  form_state.form_data.value.steps.forEach(s => s.fields.forEach(f => {
    if(f.Kind == "UserEmail"){
      userEmail = f.user_input
    // if ((f.Kind == "Checkbox") && (((f.title.toUpperCase().indexOf("CONF")>-1)||(f.title.toUpperCase().indexOf("BEVESTIGING")>-1)) && (f.title.toUpperCase().indexOf("MAIL")>-1) ))
      ConfirmationEmail= f.user_input
    }
  }))
  let raw_content = JSON.stringify(steps.map(s => ({fields:s.fields})))
  let content = {
    RawContent : raw_content,
    UserEmail : userEmail,
    ConfirmationEmail : ConfirmationEmail,
  }
    
  return loadingAsyncState(async () => {
        let fetch_res = await fetch(`/api/v1/CustomFormLogic/SubmitFormData/${form_id}`, 
                                { method: 'put', 
                                  body: JSON.stringify(content),
                                  credentials: 'include', 
                                  headers: { 'content-type': 'application/json' } 
                                })
        if(!fetch_res.ok) return {kind:"failed", status:400 }
        let res : HttpResult<string> = {kind:"result", status:200, value:"ok"}
        return res
    })
}


export let getFormState = (events: string[], form_title: string): FormState => {
  let res: FormState = {
    form_submission_logic: unloadedAsyncState(),
    dependencies_state: Immutable.Map(),
    context: {
      external_options: unloadedAsyncState()
    },
    form_data: loadingAsyncState(async () => {
      let fetch_res = await fetch(`/api/v1/CustomFormLogic/GetFormData/${form_title}`, { method: 'get', credentials: 'include', headers: { 'content-type': 'application/json' } })
      if (!fetch_res.ok) return { kind: "failed", status: 400 }
      let data = await fetch_res.json()
      data.steps = data.steps.map(step =>
        ({
          ...step,
          fields: step.fields
            .sort(function(a, b){return a.itemOrderNumber - b.itemOrderNumber})
            .map(f => {
            let field = f.field
            let maybe_answers = f.maybe_answers
            let result: any = null
            if (field.Kind == "SimpleDate") {
              result = { ...field, user_input: "", maybe_answers }
            }
            else if (field.Kind == "CheckboxMultiSelect") {

              let user_input = maybe_answers.map((a): string => {
                if (a.isDefaultSelected) {
                  return "[" + a.value + "]"
                }
                return ""
              })
              if (user_input.length == 0) {
                result = { ...field, user_input: "", maybe_answers }
              }
              else {
                result = { ...field, user_input: user_input.reduce((a, b) => a + b), maybe_answers }
              }
            }
            else {
              result = { ...field, user_input: field.optionalDefaultValue ? field.optionalDefaultValue : undefined, maybe_answers }
            }
            return result
          }),
          dependencies: step.dependencies.map(f => {
            return { ...f, is_met: false }
          })
        }))

      let res: HttpResult<FormData> = { kind: "result", status: 200, value: data }
      return res
    }),
  }
  return res as any
}

// export let GetFormTitles = (events: string[]): FormState => {
//   let res: FormState = {
//     form_submission_logic: unloadedAsyncState(),
//     dependencies_state: Immutable.Map(),
//     context: {
//       external_options: Immutable.Map<string, string[]>().set("locationArray", events)
//     },
//     form_data: loadingAsyncState(async () => {
//       let fetch_res = await fetch(`/api/v1/CustomFormLogic/GetFormTitles`, { method: 'get', credentials: 'include', headers: { 'content-type': 'application/json' } })
//       if (!fetch_res.ok) return { kind: "failed", status: 400 }
//       let data = await fetch_res.json()
//       data.steps = data.steps.map(step =>
//         ({
//           ...step,
//           fields: step.fields.map(f => {
//             let field = f.field
//             let maybe_answers = f.maybe_answers
//             let result = { ...field, user_input: field.optionalDefaultValue ? field.optionalDefaultValue : undefined, maybe_answers }
//             return result
//           }),
//           dependencies: step.dependencies.map(f => {
//             return { ...f, is_met: false }
//           })
//         }))

//       let res: HttpResult<FormData> = { kind: "result", status: 200, value: data }
//       return res
//     }),
//   }
//   return res as any
// }


// WEBPACK FOOTER //
// ./Client/components/form/api.ts